import React from 'react';
import { Box, Typography } from '@mui/material';
import { Order } from '@m4a3/api-client';
import { PopupState, bindTrigger } from 'material-ui-popup-state/hooks';
import { RightArrowWithCircleBackground } from '../../../components/RightArrowWithCircleBackground';

interface PadSelectorBarProps {
  order: Order;
  popupStateAircraft: PopupState;
  popupStateArrivalPad: PopupState;
  getDeparturePadButtonText: () => string;
  getArrivalPadButtonText: () => string;
  shouldEnableArrivalPadTag: () => boolean;
}

/**
 * Reusable component for displaying and selecting departure/arrival pads
 * Shows at the bottom of order cards when order is in certain statuses
 */
export const PadSelectorBar: React.FC<PadSelectorBarProps> = ({
  order,
  popupStateAircraft,
  popupStateArrivalPad,
  getDeparturePadButtonText,
  getArrivalPadButtonText,
  shouldEnableArrivalPadTag
}) => {

  return (
    <>
      <Box 
        sx={{ 
          backgroundColor: '#F7F7FC',
          borderTop: '1px solid #D9DBE9',
          padding: '8px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: 2,
          borderBottomLeftRadius: 16,
          borderBottomRightRadius: 16
        }}
      >
        {/* Departure Pad */}
        <Box 
          {...bindTrigger(popupStateAircraft)}
          onClick={(e) => {
            e.stopPropagation();
            bindTrigger(popupStateAircraft).onClick(e);
          }}
          sx={{ 
            flex: 1,
            backgroundColor: '#FFFFFF',
            border: '1px solid #D9DBE9',
            borderRadius: 2,
            padding: '12px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            cursor: 'pointer',
            '&:hover': {
              backgroundColor: '#F9FAFB'
            }
          }}
        >
          <Typography variant="body2" style={{ fontSize: 12, fontWeight: 600, color: '#14142B' }}>
            {getDeparturePadButtonText()}
          </Typography>
        </Box>

        {/* Arrow */}
        <Box sx={{ flexShrink: 0 }}>
          <RightArrowWithCircleBackground size={25} />
        </Box>

        {/* Arrival Pad */}
        <Box 
          {...(shouldEnableArrivalPadTag() ? bindTrigger(popupStateArrivalPad) : {})}
          onClick={(e) => {
            e.stopPropagation();
            if (shouldEnableArrivalPadTag()) {
              bindTrigger(popupStateArrivalPad).onClick(e);
            }
          }}
          sx={{ 
            flex: 1,
            backgroundColor: '#FFFFFF',
            border: '1px solid #D9DBE9',
            borderRadius: 2,
            padding: '12px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            cursor: shouldEnableArrivalPadTag() ? 'pointer' : 'not-allowed',
            opacity: shouldEnableArrivalPadTag() ? 1 : 0.6,
            '&:hover': {
              backgroundColor: shouldEnableArrivalPadTag() ? '#F9FAFB' : '#FFFFFF'
            }
          }}
        >
          <Typography variant="body2" style={{ fontSize: 12, fontWeight: 600, color: '#14142B' }}>
            {getArrivalPadButtonText()}
          </Typography>
        </Box>
      </Box>
    </>
  );
};

